import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { MenuItemDto } from '@core/services/api-clients';
import { MatNavList, MatListItem } from '@angular/material/list';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-menu-group-items',
    templateUrl: './menu-group-items.component.html',
    styleUrls: ['./menu-group-items.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatNavList,
        MatTooltip,
        MatIconButton,
        MatIcon,
        MatListItem,
        MenuItemComponent,
        TranslatePipe,
    ]
})
export class MenuGroupItemsComponent {
  readonly menuItems = input<MenuItemDto[]>(undefined);
  readonly isWide = input<boolean>(false);
  readonly isFavoriteEnabled = input<boolean>(false);
  readonly isFavorite = input<{
    [id: string]: boolean;
}>(null);
  readonly selectedMenuItemId = input<string>(undefined);
  readonly isSpecial = input<boolean>(false);
  readonly isSelectable = input<boolean>(true);
  readonly menuItemClick = output<MenuItemDto>();
  readonly menuItemAddedToFavorite = output<MenuItemDto>();
  readonly menuItemRemovedFromFavorite = output<MenuItemDto>();

  onMenuItemClick(menuItem: MenuItemDto) {
    this.menuItemClick.emit(menuItem);
  }

  addMenuItemToFavorite(menuItem: MenuItemDto) {
    this.menuItemAddedToFavorite.emit(menuItem);
  }

  removeMenuItemFromFavorite(menuItem: MenuItemDto) {
    this.menuItemRemovedFromFavorite.emit(menuItem);
  }
}
